<template>
    <div class="vue-tempalte">
        <div class="container">
            <div class="row justify-content-center mt-5 mb-5">
               <div class="col-md-6">
                   <form @submit.prevent="userLogin">
                       <h3>Вход</h3>

                       <div class="form-group">
                           <label>Имейл</label>
                           <input type="email" class="form-control form-control-lg" v-model="user.email" />
                       </div>

                       <div class="form-group">
                           <label>Парола</label>
                           <input type="password" class="form-control form-control-lg" v-model="user.password" />
                       </div>

                       <button :disabled="!user.email || !user.password" type="submit" class="btn btn-dark btn-lg btn-block">Вход</button>
                   </form>
               </div>
            </div>
        </div>
    </div>
</template>


<script>


export default {
  data() {
    return {
      user: {   
        email: '',
        password: ''
      }
    };
  },
  methods: {
    userLogin() {
        this.$store.dispatch('signInAction', this.user).then(() => {
            this.$router.push('/')
        })
        .catch((error) => {
          alert(error.message);
        });
    }
  }
};
</script>
